import { useCallback } from 'react';
import useAnalytics from '../../../analytics/useAnalytics';
import { REVIEW_MODE_SIDE_PANEL_EVENT_NAMES } from './analytics/event-name';
import type { ReviewAnnotationActionPayloadT, ReviewAnnotationNotePayloadT, ReviewAnnotationRevertPayloadT, ReviewAnnotationsVisibilityPayloadT, ReviewFeedbackPanelTogglePayloadT, ReviewFilterPayloadT, ReviewPageChangePayloadT, UpdateAnnotationReviewPayloadT } from './analytics/types';
const useAnalyticsForReviewSidePanel = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventUpdateAnnotationReview = useCallback((payload: UpdateAnnotationReviewPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.UPDATE_ANNOTATION_REVIEW,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewFilter = useCallback((payload: ReviewFilterPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_FILTER,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewAnnotationsVisibility = useCallback((payload: ReviewAnnotationsVisibilityPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_ANNOTATIONS_VISIBILITY,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewPageChange = useCallback((payload: ReviewPageChangePayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_PAGE_CHANGE,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewAnnotationNote = useCallback((payload: ReviewAnnotationNotePayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_ANNOTATION_NOTE,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewAnnotationAccept = useCallback((payload: ReviewAnnotationActionPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_ANNOTATION_ACCEPT,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewAnnotationReject = useCallback((payload: ReviewAnnotationActionPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_ANNOTATION_REJECT,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewAnnotationRevert = useCallback((payload: ReviewAnnotationRevertPayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_ANNOTATION_REVERT,
      payload
    });
  }, [sendEvent]);
  const sendEventReviewFeedbackPanelToggle = useCallback((payload: ReviewFeedbackPanelTogglePayloadT) => {
    sendEvent({
      action: REVIEW_MODE_SIDE_PANEL_EVENT_NAMES.REVIEW_FEEDBACK_PANEL_TOGGLE,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventUpdateAnnotationReview,
    sendEventReviewFilter,
    sendEventReviewAnnotationsVisibility,
    sendEventReviewPageChange,
    sendEventReviewAnnotationNote,
    sendEventReviewAnnotationAccept,
    sendEventReviewAnnotationReject,
    sendEventReviewAnnotationRevert,
    sendEventReviewFeedbackPanelToggle
  };
};
export default useAnalyticsForReviewSidePanel;